import { useEffect, useState } from 'react';
import FetchUsersInput from './FetchUsersInput';
import getAgentByName from '../../controllers/user/getAgentByName';
import Icon from '../HOC/Icon';
import getAccounts from '../../controllers/user/getAccounts';
import axios from 'axios';


var cancelTokenSource = null;

export default function AgentSearchInput({onChange,selectedAgent,label}) {
  const [agents,setAgents] = useState([])
  const [loadings,setLoadings] = useState({agent: false})
  const [value,setValue] = useState('');

  useEffect(() => {
    loadAgents()
    //eslint-disable-next-line
  },[value])
  
  async function loadAgents() {
    console.log('here')
    const params = {
      populate: "detail",
      limit: 20,
    };
    if (value) {
      params.searchBy = "firstName,lastName,email,phone";
      params.keyword = value;
    }

    if(cancelTokenSource) {
        cancelTokenSource.cancel('Request canceled.')
    }
    cancelTokenSource = axios.CancelToken.source();
  
    
    setLoadings({...loadings,agent: true})
    const res = await getAccounts(new URLSearchParams(params).toString());
    setLoadings({...loadings,agent: false})
    if(res.return) {
      setAgents(res?.data?.data || [])
    }
  }
  return (
    <div className="flex gap-2 items-center self-start">
      <FetchUsersInput from={agents} loading={loadings?.agent} 
        value={value} setValue={setValue}
        onChange={(agent) => onChange && onChange(agent)} label={label||'Agents'}
        disableClearable={false}
      />
      {selectedAgent?._id ? 
        <Icon icon='mdi:clear-circle-outline' className='cursor-pointer'
          onClick={() => onChange(null)} 
        />
      :null}
    </div>
  )
}
